import { pushAnalyticsObjToDataLayer } from "@/utils/helper"

export const cartUpdatedModalAnalytics = isNavigateToCart => {
  const urlOfDestination = isNavigateToCart
    ? `${window.location.origin}/cart`
    : `${window.location.href}`
  const linkName = isNavigateToCart ? `view cart` : `stay here`
  const eventInfo = {
    event: "cmp:click",
    clickInternalLinks: "true",
    internalLinkPosition: "checkout redirect modal",
    internalLinkZoneName: "checkout redirect",
    internalLinkURL: urlOfDestination,
    internalLinkName: linkName,
    eventName: "checkout redirect cta",
    internalLinkType: "checkout:redirect",
    eventType: "click",
    eventAction: "redirect link click",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}
